<template>
  <div>

  </div>
</template>
<script>
  import { authService } from '@/services/authService'
  import {userInfo} from "@/controllers/UserInfo";

  export default {
    name: 'Exit',

    async created() {

      await authService.logout()
      await this.$store.commit('resetState')
      // await userInfo.resetUser()
      await this.redirect()

      // await this.$router.push({ name: 'login' })

    },
    mounted() {

    },
    methods: {
      async redirect() {
        // await this.$router.push('/')
        window.location.href = "/en/login"
      }
    }
  }

</script>
